<template>
  <el-dialog
    title=""
    :visible.sync="show"
    width="420px"
    custom-class="singup-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="close"
  >
    <div class="signup-popup">
      <div class="signup-header">
        <div class="signup-title">报名观看</div>
      </div>
      <div class="signup-room" v-if="roomConfig && roomConfig.roomId">
        <img
          class="signup-room-pic"
          :src="roomConfig.roomMainPic"
          alt=""
        />
        <div class="signup-room-right">
          <div class="signup-room-name line-clamp-2">{{ roomConfig.roomName || '' }}</div>
          <div
            class="signup-room-tips"
            v-if="roomConfig.signupConfigDTO && roomConfig.signupConfigDTO.signupTips"
          >
            {{ roomConfig.signupConfigDTO.signupTips }}
          </div>
        </div>
      </div>
      <div class="signup-form" v-if="signupInfoList.length">
        <div
          class="signup-form-item"
          :class="{ 'is-textarea': item.attributeType === 'textarea' }"
          v-for="(item, index) in signupInfoList"
          :key="index"
        >
          <div class="form-label">
            <span v-if="item.mustFlag === 'Y'" class="required">*</span>
            {{ item.attributeDesc || item.attributeName }}
          </div>
          <div class="form-field" v-if="item.attributeType === 'textarea'">
            <el-input
              type="textarea"
              v-model="formData[item.attributeName]"
              :placeholder="item.placeholder"
              :maxlength="30"
              :autosize="{ minRows: 4, maxRows: 6 }"
              resize="none"
            />
          </div>
          <div class="form-field" v-else>
            <el-input
              v-model="formData[item.attributeName]"
              :placeholder="item.placeholder"
              clearable
              :maxlength="getMaxLength(item)"
              :type="item.attributeName === 'mobile' ? 'tel' : 'text'"
            />
          </div>
        </div>
      </div>
      <div class="signup-footer">
        <div
          class="signup-submit-btn"
          :class="{ 'is-loading': submitLoading }"
          @click="handleSubmit"
        >
          {{ submitLoading ? '提交中...' : '提交报名' }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Singup',
  props: {
    roomConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: false,
      submitLoading: false,
      formData: {},
    };
  },
  computed: {
    signupInfoList() {
      const raw = this.roomConfig?.signupConfigDTO?.signupInfo;
      if (!Array.isArray(raw)) return [];
      return raw.filter((item) => item.openFlag === 'Y');
    },
  },
  mounted() {
    this.showSignUp();
  },
  methods: {
    showSignUp() {
      this.show = true;
      const initial = {};
      this.signupInfoList.forEach((item) => {
        initial[item.attributeName] =
          item.attributeValue != null ? String(item.attributeValue) : '';
      });
      this.formData = initial;
    },
    close() {
      this.show = false;
    },
    getMaxLength(item) {
      const name = (item.attributeName || '').toLowerCase();
      if (name === 'name') return 6;
      if (name === 'mobile' || name === 'phone') return 11;
      return 30;
    },
    validateForm() {
      const mobileReg = /^1\d{10}$/;
      for (const item of this.signupInfoList) {
        const val = (this.formData[item.attributeName] || '').trim();
        const name = (item.attributeName || '').toLowerCase();
        if (item.mustFlag === 'Y' && !val) {
          this.$message({
            type: 'warning',
            message: item.attributeDesc || `请填写${item.attributeName}`,
          });
          return false;
        }
        if (name === 'name' && val.length > 6) {
          this.$message({ type: 'warning', message: '姓名长度不能超过6位' });
          return false;
        }
        if ((name === 'mobile' || name === 'phone') && val && !mobileReg.test(val)) {
          this.$message({ type: 'warning', message: '请输入正确的11位手机号' });
          return false;
        }
        if (name !== 'name' && name !== 'mobile' && name !== 'phone' && val.length > 30) {
          this.$message({ type: 'warning', message: '自定义内容最长30个字符' });
          return false;
        }
      }
      return true;
    },
    async handleSubmit() {
      if (this.submitLoading) return;
      if (!this.validateForm()) return;
      if (!this.roomConfig || !this.roomConfig.roomId) {
        this.$message({ type: 'error', message: '直播间信息异常' });
        return;
      }
      this.submitLoading = true;
      try {
        const signupInfo = this.signupInfoList.map((item) => ({
          attributeName: item.attributeName,
          attributeValue:
            this.formData[item.attributeName] != null
              ? String(this.formData[item.attributeName]).trim()
              : '',
        }));
        await this.$liveapi.addOrUpdateSignupUser({
          roomId: this.roomConfig.roomId,
          signupInfo,
        });
        this.$message({ type: 'success', message: '报名成功' });
        this.close();
        this.$emit('success');
      } catch (e) {
        this.$message({
          type: 'error',
          message: (e && e.message) || '报名失败',
        });
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.signup-popup {
  background: #fff;
  border-radius: 16px;
  box-sizing: border-box;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  margin: -8px 0 0;
}

.signup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.signup-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.signup-room {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.signup-room-pic {
  width: 108px;
  height: 81px;
  border-radius: 8px;
  background: #f5f5f5;
  flex-shrink: 0;
  object-fit: cover;
}

.signup-room-right {
  flex: 1;
  min-width: 0;
}

.signup-room-name {
  font-size: 16px;
  color: #333;
  line-height: 1.4;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.signup-room-tips {
  font-size: 14px;
  color: #999;
  line-height: 1.5;
  margin-top: 6px;
  word-break: break-all;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.signup-form {
  flex: 1;
  overflow-y: auto;
  margin: 12px 0 16px;
  padding-right: 4px;
}

.signup-form-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  min-height: 56px;
  padding: 8px 0;

  &.is-textarea {
    align-items: flex-start;
    min-height: auto;
    padding: 12px 0;
  }
}

.form-label {
  font-size: 14px;
  color: #333;
  flex-shrink: 0;
  width: 90px;
  text-align: right;
  padding-right: 10px;
  line-height: 36px;

  .is-textarea & {
    line-height: 1.4;
    padding-top: 8px;
  }
}

.form-field {
  flex: 1;
  min-width: 0;
  padding-left: 10px;
}

.form-label .required {
  color: #fa5552;
  margin-right: 2px;
}

.signup-footer {
  padding-top: 8px;
}

.signup-submit-btn {
  height: 50px;
  border-radius: 27px;
  background: #fe2c55;
  border: none;
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  line-height: 50px;
  color: #fff;
  cursor: pointer;

  &.is-loading {
    opacity: 0.7;
    pointer-events: none;
  }
}
</style>

<style lang="scss">
.singup-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 20px 20px 24px;
  }
}
</style>
